import './PageList.scss';

export { default } from './PageList';
